import axios from "axios";
import {
  DataGridRequestParams,
  GridInvoiceList,
  GridInvoice,
} from "fe-shared-transactions/src/types";
import { PAGE_SIZE } from "consts";

export const getInvoices = (
  queryKey: string,
  requestParams: DataGridRequestParams,
  page: number | null = 1
): Promise<GridInvoiceList<GridInvoice>> => {
  return axios
    .post<GridInvoiceList<GridInvoice>>("invoices/getInvoices", {
      ...requestParams,
      ...(page !== null
        ? { limit: PAGE_SIZE, skip: PAGE_SIZE * (page - 1) }
        : {}),
    })
    .then((res) => res.data);
};

export default getInvoices;
